@if (!isHidden) {
  <div
    #wrapper
    class="floating-feedback-button-wrapper ignore-export"
    [class.floating-feedback-button-wrapper--top-menu]="isTopMenuLayout()"
    [class.bubble-active]="(showBubble && !isPanelOpen && !isInModalMode) || contextMenuVisible"
    [class.dragging]="isDragging"
    [class.fab-faded]="fabFaded && !isRecording"
    [class.fab-tucked]="isTuckActive"
    [ngStyle]="buttonStyle"
    (mouseenter)="onFabMouseEnter()"
    (mouseleave)="onFabMouseLeave()"
    (mousedown)="startDrag($event)"
    (touchstart)="startDrag($event)"
    (contextmenu)="onContextMenu($event)">
    <!-- Com modal ou drawer aberto, só o avatar: o balão cobria botões do rodapé (Kit Banco, PBI 3800). -->
    @if (showBubble && !isPanelOpen && !contextMenuVisible && !isInModalMode) {
      <div
        class="feedback-speech-bubble feedback-bubble"
        [class.feedback-speech-bubble--end]="!bubbleOpensLeft"
        (mousedown)="$event.stopPropagation()">
        <span class="feedback-bubble__text">Ajude-nos a evoluir o Cognito</span>
        <button
          type="button"
          class="feedback-bubble__close"
          (mousedown)="$event.stopPropagation()"
          (click)="closeBubble(); $event.stopPropagation()">
          <i class="pi pi-times"></i>
        </button>
      </div>
    }
    @if (contextMenuVisible) {
      <div
        class="feedback-context-menu ignore-export"
        [class.feedback-context-menu--end]="!bubbleOpensLeft">
        <button type="button" class="feedback-context-menu__item">
          <i class="pi pi-eye-slash"></i>
          Ocultar
        </button>
      </div>
    }
    <button
      #fab
      type="button"
      class="floating-feedback-button"
      [class.floating-feedback-button--recording]="isRecording"
      (click)="onClick()">
      <img
        class="floating-feedback-button__avatar"
        src="assets/images/feedback-avatar.png"
        alt="Feedback" />
    </button>
    @if (isRecording) {
      <div class="floating-feedback-recording-ring" aria-hidden="true"></div>
      <div class="floating-feedback-rec-badge" aria-hidden="true">
        <span class="floating-feedback-rec-dot"></span>
        REC {{ recordingTimeDisplay }}
      </div>
    }
    <button
      type="button"
      class="floating-feedback-minimize"
      (mousedown)="$event.stopPropagation()"
      (touchstart)="$event.stopPropagation()"
      (click)="onMinimizeClick($event)">
      <i class="pi pi-times"></i>
    </button>
    <div
      class="feedback-speech-bubble floating-feedback-button-tooltip"
      [class.feedback-speech-bubble--end]="!bubbleOpensLeft">
      Reportar
    </div>
  </div>

  <app-feedback-panel
    [screenshotBlob]="screenshotBlob"
    [isOpen]="isPanelOpen"
    [isCapturingScreenshot]="isCapturingScreenshot"
    (closed)="onClosePanel()"
    (submitted)="onFeedbackSubmitted()"
    (initialCaptureScreenshot)="onInitialCaptureScreenshot()"
    (recaptureScreenshot)="onRecaptureScreenshot()"
    (clearScreenshot)="onClearScreenshot()"
    (recordingStateChanged)="onRecordingStateChanged($event)" />
}
